<style scoped>
</style>

<template>
  <div class="jumbotron bg-transparent text-center margin-none">
    <h1>备份还原</h1>
    <p class="text-muted">导出为 zip 备份文件，导入 zip 后请重新启动通讯管理机。</p>

    <div class="row">
      <div class="col-md-6 col-xs-12">
        <div class="panel panel-default">
          <div class="panel-heading">
            <strong>导出配置</strong>
          </div>
          <div class="panel-body text-left">
            <p>导出当前管理机配置为 zip 压缩包，便于备份和迁移。</p>
            <div class="form-group">
              <input class="form-control" type="text" v-model.trim="exportName" placeholder="必填，例如：1号站">
            </div>
            <button class="btn btn-primary" @click="exportBackup">
              <i class="fa fa-download"></i> 下载配置压缩包
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xs-12">
        <div class="panel panel-default">
          <div class="panel-heading">
            <strong>导入配置</strong>
          </div>
          <div class="panel-body text-left">
            <p>选择之前导出的 zip 备份文件，上传后覆盖当前配置。</p>
            <div class="form-group">
              <input class="form-control" type="file" accept=".zip,application/zip" @change="handleFileChange">
            </div>
            <p class="text-muted" v-if="selectedFileName">已选择：{{ selectedFileName }}</p>
            <button class="btn btn-danger" :disabled="importing" @click="importBackup">
              <i class="fa fa-upload"></i> {{ importing ? '导入中...' : '上传并导入配置包' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'version',
  data() {
    return {
      exportName: '',
      selectedFile: null,
      selectedFileName: '',
      importing: false
    }
  },
  methods: {
    exportBackup: function() {
      var exportName = (this.exportName || '').trim()
      if (!exportName) {
        alert('请先填写备份名称')
        return
      }

      var link = document.createElement('a')
      var query = '?ts=' + Date.now()
      if (exportName) {
        query += '&name=' + encodeURIComponent(exportName)
      }
      link.href = '/backup/export' + query
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleFileChange: function(event) {
      var files = event.target.files || []
      if (!files.length) {
        this.selectedFile = null
        this.selectedFileName = ''
        return
      }
      this.selectedFile = files[0]
      this.selectedFileName = files[0].name
    },
    importBackup: function() {
      if (!this.selectedFile) {
        alert('请先选择 zip 配置包')
        return
      }

      var form = new FormData()
      form.append('file', this.selectedFile)
      this.importing = true

      var xhr = new XMLHttpRequest()
      xhr.open('POST', '/backup/import', true)
      xhr.onreadystatechange = function() {
        if (xhr.readyState !== 4) {
          return
        }

        this.importing = false

        if (xhr.status < 200 || xhr.status >= 300) {
          var failed = this.parseResponse(xhr.responseText)
          alert(failed.message || '导入配置压缩包失败')
          return
        }

        var result = this.parseResponse(xhr.responseText)
        if (result.error) {
          alert(result.message || '导入配置压缩包失败')
          return
        }

        alert(result.message || '配置导入完成，请重新启动通讯管理机')
        this.resetSelection()
      }.bind(this)

      xhr.onerror = function() {
        this.importing = false
        alert('导入配置压缩包时服务器异常')
      }.bind(this)

      xhr.send(form)
    },
    parseResponse: function(text) {
      try {
        return JSON.parse(text || '{}')
      } catch (e) {
        return {}
      }
    },
    resetSelection: function() {
      this.selectedFile = null
      this.selectedFileName = ''
      var input = this.$el.querySelector('input[type="file"]')
      if (input) {
        input.value = ''
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// Version.vue?64e4b3b4